module.exports = __webpack_public_path__ + "img/vespa_160.280e2ddb.png";